var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16666 18.9998H34.8333M3.16666 18.9998C3.16666 27.7443 10.2555 34.8332 19 34.8332M3.16666 18.9998C3.16666 10.2553 10.2555 3.1665 19 3.1665M34.8333 18.9998C34.8333 27.7443 27.7445 34.8332 19 34.8332M34.8333 18.9998C34.8333 10.2553 27.7445 3.1665 19 3.1665M19 3.1665C22.9603 7.50223 25.211 13.1289 25.3333 18.9998C25.211 24.8708 22.9603 30.4974 19 34.8332M19 3.1665C15.0396 7.50223 12.789 13.1289 12.6667 18.9998C12.789 24.8708 15.0396 30.4974 19 34.8332",
    stroke: "#14B8A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe01);
export default __webpack_public_path__ + "static/media/globe-01.69a8e9c08123afb4e22b4f7cd931e101.svg";
export { ForwardRef as ReactComponent };